"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
// The bus-certificate node carries no configuration of its own: it is a
// terminal trigger that resolves everything it needs (the servicing cycle, the
// facility, the credit agreement) at run time from the pipeline run. So the UI
// config is just the artifact slug and the intermediate config is empty.
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
});
exports.nodeType = 'file_busCertificate';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'busCertificate';
//# sourceMappingURL=types.js.map